import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { verifyInstituteEmail } from '../../api/institute';

const VerifyInstitute = () => {
    const { token } = useParams()
    const history = useHistory()
    const [loading, setLoading] = useState(true)
    const [verified, setVerified] = useState(false)
    const { user } = useSelector((state) => ({ ...state }));

    useEffect(() => {
        verifyInstituteEmail(token)
            .then(res => {
                setVerified(true)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
                history.push('/')
            })

    }, [])

    useEffect(() => {
        if (user && user.token) {
            if (verified) {
                toast.success('email successfully verified')
                history.push(`/admin/dashboard`)
            }
        }
    }, [user, verified])

    return (
        <div>
            {loading ? <h1>loading</h1> : <h1>Email succesfully verified please login to continue</h1>}
        </div>
    );
};

export default VerifyInstitute;